export default function Projects() {
  const projects = [
    {
      title: 'Hotel Boutique Barcelona',
      category: 'Hospitalidad',
      description: 'Suministro completo de revestimientos de mármol, sanitarios premium y grifería de diseño para 45 habitaciones y zonas comunes.',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20boutique%20hotel%20lobby%20interior%20with%20premium%20marble%20flooring%2C%20elegant%20wall%20cladding%2C%20modern%20designer%20lighting%20fixtures%2C%20sophisticated%20furniture%2C%20contemporary%20architectural%20design%2C%20high-end%20finishes%2C%20professional%20photography%2C%20warm%20ambient%20lighting%20creating%20upscale%20atmosphere&width=700&height=500&seq=project-zhongming-009&orientation=landscape',
      stats: { area: '2,500 m²', duration: '4 meses', year: '2023' }
    },
    {
      title: 'Residencial Premium Madrid',
      category: 'Residencial',
      description: 'Pavimentos técnicos, puertas lacadas y carpintería interior para complejo residencial de 120 viviendas de alto standing.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20residential%20apartment%20interior%20with%20premium%20wood%20flooring%2C%20contemporary%20white%20lacquered%20doors%2C%20elegant%20carpentry%20details%2C%20minimalist%20design%2C%20high-quality%20finishes%2C%20spacious%20living%20room%20with%20natural%20light%2C%20sophisticated%20urban%20living%20space&width=700&height=500&seq=project-zhongming-010&orientation=landscape',
      stats: { area: '8,000 m²', duration: '8 meses', year: '2023' }
    },
    {
      title: 'Oficinas Corporativas Valencia',
      category: 'Comercial',
      description: 'Iluminación arquitectónica LED, fachada ventilada y sistemas de climatización para edificio corporativo de nueva construcción.',
      image: 'https://readdy.ai/api/search-image?query=Contemporary%20corporate%20office%20building%20exterior%20with%20modern%20ventilated%20facade%20system%2C%20architectural%20LED%20lighting%2C%20aluminum%20composite%20panels%2C%20glass%20curtain%20walls%2C%20professional%20commercial%20architecture%2C%20clean%20lines%2C%20blue%20sky%20background%2C%20urban%20business%20district&width=700&height=500&seq=project-zhongming-011&orientation=landscape',
      stats: { area: '5,500 m²', duration: '6 meses', year: '2024' }
    },
    {
      title: 'Centro Comercial Sevilla',
      category: 'Retail',
      description: 'Pavimentos de alto tránsito, revestimientos cerámicos y elementos decorativos para centro comercial de 3 plantas.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20shopping%20mall%20interior%20with%20high-traffic%20premium%20flooring%2C%20elegant%20ceramic%20wall%20tiles%2C%20contemporary%20retail%20design%2C%20spacious%20corridors%2C%20designer%20lighting%2C%20clean%20commercial%20space%2C%20professional%20architecture%2C%20shoppers%20walking%2C%20bright%20and%20welcoming%20atmosphere&width=700&height=500&seq=project-zhongming-012&orientation=landscape',
      stats: { area: '12,000 m²', duration: '10 meses', year: '2023' }
    },
    {
      title: 'Restaurante Gastronómico Bilbao',
      category: 'Hospitalidad',
      description: 'Revestimientos especiales, iluminación decorativa y mobiliario de diseño para restaurante de alta cocina con estrella Michelin.',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20Michelin%20star%20restaurant%20interior%20with%20sophisticated%20wall%20cladding%2C%20designer%20pendant%20lighting%2C%20premium%20materials%2C%20contemporary%20fine%20dining%20atmosphere%2C%20luxury%20furniture%2C%20warm%20ambient%20lighting%2C%20professional%20interior%20design%2C%20upscale%20gastronomy%20setting&width=700&height=500&seq=project-zhongming-013&orientation=landscape',
      stats: { area: '450 m²', duration: '3 meses', year: '2024' }
    },
    {
      title: 'Clínica Dental Málaga',
      category: 'Salud',
      description: 'Pavimentos sanitarios, revestimientos antibacterianos y sistemas de iluminación técnica para clínica dental de última generación.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20dental%20clinic%20interior%20with%20hygienic%20white%20flooring%2C%20antibacterial%20wall%20coverings%2C%20professional%20medical%20lighting%20systems%2C%20clean%20minimalist%20design%2C%20contemporary%20healthcare%20facility%2C%20sterile%20environment%2C%20advanced%20dental%20equipment%2C%20bright%20and%20welcoming%20medical%20space&width=700&height=500&seq=project-zhongming-014&orientation=landscape',
      stats: { area: '800 m²', duration: '2 meses', year: '2024' }
    }
  ];

  return (
    <section id="projects" className="py-24 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Proyectos Destacados
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-6">
            Colaboraciones Exitosas
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Hemos colaborado con los mejores profesionales del sector en proyectos de gran envergadura por toda España. Cada proyecto es una muestra de nuestro compromiso con la excelencia.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-blue-900 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {project.category}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-blue-900 mb-3">{project.title}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">{project.description}</p>
                <div className="grid grid-cols-3 gap-4 pt-4 border-t border-gray-200">
                  <div>
                    <div className="text-xs text-gray-500 mb-1">Superficie</div>
                    <div className="font-semibold text-blue-900 text-sm">{project.stats.area}</div>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500 mb-1">Duración</div>
                    <div className="font-semibold text-blue-900 text-sm">{project.stats.duration}</div>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500 mb-1">Año</div>
                    <div className="font-semibold text-blue-900 text-sm">{project.stats.year}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">¿Tienes un proyecto en mente?</p>
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-blue-900 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-800 transition-colors shadow-lg whitespace-nowrap cursor-pointer inline-block"
          >
            <i className="ri-chat-3-line mr-2"></i>
            Cuéntanos tu Proyecto
          </button>
        </div>
      </div>
    </section>
  );
}
